<template>
	<div>
		<img src="@/assets/images/new/mask-top-right.png" class="bg-t-r" />
		<img src="@/assets/images/new/mask-bottom-left.png" class="bg-b-l" />
		<div class="logo"><img src="@/assets/images/logo.png" @click.stop="clickLogo" /></div>
		<img v-if="!home" src="@/assets/images/new/home.svg" class="homeIcon" @click.stop="clickHome" />
		<svg v-if="!home" class="retrunIcon" @click.stop="clickRetrun" width="25.5px" height="25.5px">
			<path
				fill-rule="evenodd"
				stroke="rgb(153, 29, 133)"
				stroke-width="1px"
				stroke-linecap="butt"
				stroke-linejoin="miter"
				fill="none"
				d="M12.461,0.500 C5.855,0.500 0.500,5.855 0.500,12.462 C0.500,19.068 5.855,24.423 12.461,24.423 C19.068,24.423 24.423,19.068 24.423,12.462 C24.423,5.855 19.068,0.500 12.461,0.500 Z"
			/>
			<path
				fill-rule="evenodd"
				fill="rgb(153, 29, 133)"
				d="M15.063,17.627 C15.347,17.910 15.375,18.339 15.127,18.586 C14.879,18.833 14.446,18.804 14.162,18.522 L8.599,13.025 C8.438,12.865 8.362,12.658 8.369,12.464 C8.361,12.268 8.437,12.060 8.599,11.898 L14.162,6.401 C14.446,6.119 14.878,6.090 15.127,6.338 C15.375,6.585 15.347,7.014 15.063,7.296 L9.832,12.462 L15.063,17.627 Z"
			/>
		</svg>
		<div class="navBg" :class="{ notNav: !nav }"></div>
		<div class="placeholder clear" :class="{ notNav: !nav }"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	props: {
		nav: {
			typeof: Boolean,
			default: true
		},
		home: {
			typeof: Boolean,
			default: false
		}
	},
	computed: {},
	mounted() {},
	methods: {
		clickHome() {
			this.$emit('home');
			this.$dataStatistics({ event_type: 'click', page_title: '返回首页' });
			this.$router.push('/');
		},
		clickRetrun() {
			this.$emit('retrun');
			this.$dataStatistics({ event_type: 'click', page_title: '返回上一页' });
			this.$router.go(-1);
		},
		clickLogo() {
			this.$emit('logo');
			this.$dataStatistics({ event_type: 'click', page_title: '点击logo' });
		}
	},
	activated() {}
};
</script>
<style lang="less" scoped>
.bg-t-r {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 10;
	display: block;
	width: 222px;
	height: 204px;
	pointer-events: none;
	transform: translateY(-20px);
}

.bg-b-l {
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 4;
	display: block;
	width: 189px;
	height: 227px;
	pointer-events: none;
}

.logo {
	position: fixed;
	top: 27px;
	left: 35px;
	width: 214px;
	height: 55px;
	display: block;
	z-index: 111;
	& > img {
		width: 100%;
	}
}

.retrunIcon {
	position: fixed;
	top: 20px;
	right: 26px;
	display: block;
	z-index: 111;
	box-sizing: content-box;
	padding: 10px;
	transform: scale(0.9);
}

.homeIcon {
	position: fixed;
	top: 22px;
	right: 114px;
	width: 45px;
	height: 45px;
	display: block;
	z-index: 111;
	box-sizing: content-box;
	padding: 10px;
	transform: scale(1);
}

.navBg {
	position: fixed;
	top: 0;
	left: 0;
	width: 828px;
	height: 200px;
	display: block;
	z-index: 9;
	background: #ffffff;
	box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.03);

	&::after {
		content: '';
		background-color: rgba(153, 29, 133, 0.12);
		position: absolute;
		bottom: 90px;
		left: 0;
		display: block;
		width: 100%;
		height: 1.5px;
		transform: translateY(50%);
		z-index: 6;
	}

	&.notNav {
		height: 110px;
		&::after {
			bottom: 0;
			transform: translateY(0);
		}
	}
}

.placeholder {
	width: 828px;
	height: 200px;
	display: block;

	&.notNav {
		height: 110px;
	}
}
</style>
